import Gauge from '@/components/Gauge';
import { toFactor } from '@/utilities/formatting';

export interface Props {
  companyName: string;
  companyPE: number;
  industryName: string;
  industryPE: number;
  marketName: string;
  marketPE: number;
}

const keys = ['company', 'industry', 'market'];

const PERatioGauge = ({
  companyPE,
  industryPE,
  marketPE,
  companyName,
  industryName,
  marketName,
}: Props) => {
  const entities = {
    [keys[0]]: companyPE,
    [keys[1]]: industryPE,
    [keys[2]]: marketPE,
  };
  const entityTitles = {
    [keys[0]]: companyName,
    [keys[1]]: industryName,
    [keys[2]]: marketName,
  };
  return (
    <Gauge
      title="PE Ratio"
      entityTitles={entityTitles}
      keys={keys}
      entities={entities}
      formatter={(value: number | null) =>
        value !== null ? toFactor(value, 1) : 'n/a'
      }
      numTicks={6}
      from={0}
      to={60}
      flip={true}
    />
  );
};

export default PERatioGauge;
